export default [
    {
        path: '/orders',
        name: 'LeadIndex',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Leads',
            fullHeight: true,
        },
        components: {
            default: () => import('@views/leads/LeadsIndex.vue'),
        },
    },
    {
        path: '/orders/create',
        name: 'LeadCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create lead',
        },
        components: {
            default: () => import('@views/leads/LeadCreate.vue'),
        },
    },
    {
        path: '/orders/:id/view',
        name: 'OrderView',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Order',
        },
        beforeEnter: async (to, from, next) => {
            const id = to.params.id;
            // Check if ID is valid - not undefined, null, "undefined", or non-numeric
            if (!id || id === 'undefined' || id === 'null' || isNaN(Number(id)) || Number(id) <= 0) {
                next({ name: 'OrderNotFound' });
            } else {
                const userStore = useUserStore();

                if (!userStore.isOnlyFieldStaff()) {
                    next();
                    return;
                }

                let resp;
                try {
                    ({ data: resp } = await window.tenantAxios.get(`/orders/${id}/pre-job-checklist`));
                } catch (error) {
                    // Fail open: the checklist is a workflow aid, not an access control,
                    // and a failed fetch must not strand field staff outside the order.
                    console.error('Pre-job checklist could not be loaded; opening the order.', error);
                    next();
                    return;
                }

                if (resp.is_each_form_filled) {
                    next();
                    return;
                }

                // The checklist hands off here with `bypassChecklist` after a skip.
                // Honour it only once every mandatory form is filled, so a typed
                // URL cannot walk past the gate the checklist just enforced.
                if (to.query.bypassChecklist && resp.is_each_mandatory_form_filled !== false) {
                    next();
                    return;
                }

                next({ name: 'OrderPreJobChecklist', params: { id, formData: resp } });
            }
        },
        props: {
            default: (route) => ({ id: route.params.id, bypassChecklist: route.params.bypassChecklist ?? false }),
        },
        components: {
            default: () => import('@views/orders/Order.vue'),
        },
    },
    {
        path: '/orders/:id/pnl',
        name: 'OrderPnL',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Order P&L',
        },
        beforeEnter: (to, from, next) => {
            const id = to.params.id;
            if (!id || id === 'undefined' || id === 'null' || isNaN(Number(id)) || Number(id) <= 0) {
                next({ name: 'OrderNotFound' });
            } else {
                next();
            }
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/OrderPnL.vue'),
        },
    },
    {
        path: '/orders/:id/inventory',
        name: 'OrderInventory',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Inventory',
            fullHeight: true,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/OrderInventory.vue'),
        },
    },
    {
        path: '/orders/:id/inventory/condition-report',
        name: 'OrderInventoryConditionReport',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Inventory condition report',
            fullHeight: true,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/OrderInventoryConditionReport.vue'),
        },
    },
    {
        path: '/orders/:id/inventory/condition-report/sign-off',
        name: 'IcrSignOff',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'ICR sign off',
            fullHeight: true,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/IcrSignOff.vue'),
        },
    },
    {
        path: '/orders/:id/inventory/condition-report/view-signed-off',
        name: 'IcrViewSignedOff',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'View signed off',
            fullHeight: true,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/IcrViewSignedOff.vue'),
        },
    },
    {
        path: '/orders/:id/pre-job-checklist',
        name: 'OrderPreJobChecklist',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Pre-job checklist',
        },
        props: {
            default: (route) => ({ id: route.params.id, formData: route.params.formData }),
        },
        components: {
            default: () => import('@views/orders/OrderPreJobChecklist.vue'),
        },
    },
];
